
const SELECTION_CHANGE_EVENT_DELAY = 250;

let selectionTimeout = 0;
let selectionChangeListeners = [];

/**
 * Register selection change listener
 * @param {function} listener
 */
export function addSelectionChangeListener(listener) {
	selectionChangeListeners.push(listener);
}

function fireSelectionChangeEvent() {
	selectionTimeout = 0;
	for (let listener of selectionChangeListeners) {
		listener();
	}
}

/**
 * Every object presented on the canvas must be inherited from this class
 */
export class ManipulationEditor {

	constructor(parent) {
		this.parent = parent;
		this._selected = false;
		this._hovered = false;
	}

	get lineWidth() {
		return 2;
	}

	get selected() {
		return this._selected;
	}

	set selected(s) {
		const change = s !== this._selected;
		this._selected = s;
		if (change) ManipulationEditor.selectionChanged();
	}

	get hovered() {
		return this._hovered;
	}

	set hovered(h) {
		this._hovered = h;
	}

	static selectionChanged() {
		if (selectionTimeout) window.clearTimeout(selectionTimeout);
		selectionTimeout = window.setTimeout(fireSelectionChangeEvent, SELECTION_CHANGE_EVENT_DELAY);
	}

	/**
	 * Check for mouse hit at give coordinates
	 * @param {number} x
	 * @param {number} y
	 * @return {null}
	 */
	hit(x, y) {
		return null;
	}

	/** Remember initial position to start dragging operation */
	startDragging() {}

	/**
	 * @param {number} diffX
	 * @param {number} diffY
	 * @param {[number]} snapsX
	 * @param {[number]} snapsY
	 * @return {{x: null, y: null}}
	 */
	drag(diffX, diffY, snapsX, snapsY) {
		return { x: null, y: null };
	}

	/** Finish dragging with passed difference from starting position */
	stopDragging(diffX, diffY, snapsX, snapsY) {}

	/**
	 * Calculate bounding box of the object
	 */
	calcBoundingBox() {
		return {
			top:0, left:0, width:0, height:0
		};
	}

	/**
	 * Draw the object on the canvas
	 * @param {CanvasRenderingContext2D} ctx
	 */
	draw(ctx) {
	}

	/**
	 * Draw editor's handlers for manipulation
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {number} pixelWidth stroke width which will appear exactly one hard pixel wide on the screen;
	 */
	drawHandlers(ctx, pixelWidth=1) {
	}

	verticalSnaps() {
		return [];
	}

	horizontalSnaps() {
		return [];
	}

	/**
	 * Called by SelectTool when user click object
	 * @param {MouseEvent} e original event
	 * @param {Canvas} canvas
	 * @param {{ x: {number}, y: {number} }} pos click position translated to model coordinates
	 */
	doubleClick(e, canvas, pos) {
	}
}